import {
  HowItWorksDialogUI,
  type HowItWorksDialogProps,
} from "@b2bportal/core-disruption";
import { IconNameEnum } from "@b2bportal/core-themes";

export const HowItWorksDialog = (props: HowItWorksDialogProps) => {
  const defaultIcon = {
    viewBox: "0 0 18 18",
  };
  return (
    <HowItWorksDialogUI
      {...props}
      bulletPrefixes={{
        one: {
          iconName: IconNameEnum.disruptionHowItWorksDialogBulletOne,
          ...defaultIcon,
        },
        two: {
          iconName: IconNameEnum.disruptionHowItWorksDialogBulletTwo,
          viewBox: "0 0 22 16",
        },
        three: {
          iconName: IconNameEnum.disruptionHowItWorksDialogBulletThree,
          ...defaultIcon,
        },
      }}
      importInfoPrefixes={{
        one: {
          iconName: IconNameEnum.disruptionHowItWorksDialogInfoLineOne,
          ...defaultIcon,
        },
        two: {
          iconName: IconNameEnum.disruptionHowItWorksDialogInfoLineTwo,
          ...defaultIcon,
        },
      }}
    />
  );
};
